module.exports = __webpack_public_path__ + "static/img/Dylan-Brown.d979b3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dylan-Brown.jpg
// module id = 4ghe
// module chunks = 0